<template>
    <div>
        <Navbar />
        <!-- <Header title="Event" /> -->
        <EventNew />
    </div>
</template>

<script>
import Navbar from "@/components/Navbar.vue";
// import Header from "@/components/Header.vue";
import EventNew from "@/components/EventNew.vue";

export default {
  components: {
    Navbar,
    // Header,
    EventNew
  }
}
</script>

<style lang="scss" scoped></style>